// @ts-nocheck

const config = (window as any).config;

/**
 * complete, working configuration as fallback for missing or misspelled database-config-variables
 */
const fallbackConfig: { [key: string]: any } = {
  /* tslint:disable */

  baseUrl: 'https://dahler.dr-heiko-hofer.de',
  imgBaseUrl: "https://www.dahlercompany.com",
  searchRoute: 'foofoofoofoo',

  api: {
    url: 'https://solr8.dr-heiko-hofer.de/solr/dahler/select',
    memberUrl: 'https://solr8.dr-heiko-hofer.de/solr/dahler/select',
    maxSearchResults: 500,
  },
  article: {
    apiUrl: "https://solr8.dr-heiko-hofer.de/solr/dahler_articles/select",
    imageBaseUrl: "https://www.dahlercompany.com"
  },
  map: {
    defaultCenter: [53.549451, 9.99533],
    defaultDistance: 10,
    // defaultBounds: [5.756835937500001, 47.2195681123155, 15.095214843750002, 54.939765758658936] // germany
    defaultBounds: [53.133589829244826, 9.58282470703125, 53.93992136859204, 10.744628906250002], // region Hamburg
  },
  googleMaps: {
    apiKey: 'AIzaSyCi8MVgtafIPgWxcq1BpSv-3coi42k1_-s',
    placesUrl:
      'https://maps.googleapis.com/maps/api/place/findplacefromtext/json?inputtype=textquery&fields=formatted_address,geometry,id,name,permanently_closed,type&key={apiKey}&input={search}&session={session}',
    placesAutocompleteUrl:
      'https://maps.googleapis.com/maps/api/place/autocomplete/json?components=country:de&key={apiKey}&input={search}&session={session}',

    /* deprecated: */
    // showMarkerDetails: false, // true: show all markers with image and basis info; false: dot
    // showActiveMarkerDetails: false // true: show active marker image and basis info, false: highlighted dot
    /* end deprecated */
  },

  // https://emailregex.com/
  validateMailReqex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

  validatePhoneReqex: /^[0-9]*\/*(\+49)*[ ]*(\([0-9]+\))*([ ]*(-|–)*[ ]*[0-9]+)*$/,

  /* tslint:enable */
};

class Config {
  drupalSettings = null;

  /**
   * Get config value of key. Key examples: 'helpUrl' or 'lastVisited.maxItems'
   *
   * @param key {string}
   * @returns {any}
   */
  public get(key: string): any {
    try {
      const val = key.split('.').reduce((o, i) => o[i], config);
      if (typeof val !== 'undefined') {
        return val;
      } else {
        console.warn('Config variable not found for: ', key);
        return this.getFallback(key);
      }
    } catch (e) {
      // TODO: show warning, if we change to get config from backend
      // console.log( 'Config variable not found for: ', key );
      // console.warn( e );
      return this.getFallback(key);
    }
  }

  public getDrupalVar(key: string, defaultValue: any = null): any {
    try {
      const settings = this.getDrupalSettings();
      const val = key.split('.').reduce((o, i) => o[i], settings);
      if (typeof val !== 'undefined') {
        return val;
      } else {
        return defaultValue;
      }
    } catch (e) {
      console.warn('DrupalConfig variable not found for: ', key);
    }
  }

  public isDrupalVarSet(key: string): boolean {
    try {
      const settings = this.getDrupalSettings();
      const val = key.split('.').reduce((o, i) => o[i], settings);
      if (typeof val !== 'undefined') {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  public getDrupalSettings(): any {
    if (!this.drupalSettings) {
      try {
        var settingsElement = document.querySelector('script[type="application/json"][data-drupal-selector="drupal-settings-json"]');
        this.drupalSettings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        console.error(e);
      }
    }
    return this.drupalSettings;
  }

  /**
   * on error: return fallback config value
   *
   * @param key {string}
   * @returns {any}
   */
  protected getFallback(key: string): any {
    try {
      const val = key.split('.').reduce((o, i) => o[i], fallbackConfig);
      if (typeof val !== 'undefined') {
        return val;
      } else {
        console.error('Config Error: no fallback for: ', key);
        return 0;
      }
    } catch (e) {
      console.log('Config Error: no fallback for: ', key);
      // console.error(e);
      return 0;
    }
  }
}

export default new Config();
